import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import {config} from "@/main";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/admin',
        name: 'admin',
        component: () => import('@/views/main/Main.vue'),
        children: [
            {
                path: "/admin/:pathMatch(.*)",
                name: "404",
                component: () => import('@/views/manage/Transition.vue'),
            },
            {
                path: "/admin/EditArticle",
                name: "EditArticle",
                component: () => import('@/views/manage/EditArticle.vue'),
                meta: {
                    title: "编辑文档",
                    parentPath: "/admin/article"
                }
            },
            {
                path: "/admin/NewEditArticle",
                name: "NewEditArticle",
                component: () => import('@/views/manage/NewEditArticle.vue'),
                meta: {
                    title: "编辑文档",
                    parentPath: "/admin/article"
                }
            }
        ]
    },

    {
        path: "/:pathMatch(.*)",
        name: "Global404",
        component: () => import('@/views/manage/Transition.vue'),
    },
    {
        path: '/admin/login',
        name: 'login',
        component: () => import('@/views/login/Login.vue')
    },
    {
        path: "/",
        name: "index",
        component: () => import('@/views/index/Index.vue')
    },
    {
        path: "/doc/:projectId/:menuId?/:docId?",
        name: "doc",
        component: () => import('@/views/index/Main.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    // document.title = "Langolink";
    let token = config.auth.getToken();
    if (token || to.path === "/admin/login" || to.path.split('/')[1] !== 'admin') {
        next();
    } else {
        next("/admin/login");
    }
});

export default router
